import { forwardRef } from 'react'

import { backends } from './backends'
import type { PlayerHandle, PlayerProps } from './types'

// 顶层纯渲染 Player：按 backend 选择后端组件（默认 html-video），
// 透传 source / className / 事件回调，并把命令式句柄 forward 给后端。
const Player = forwardRef<PlayerHandle, PlayerProps>(({ backend = 'html-video', ...backendProps }, ref) => {
  const Backend = backends[backend]
  return <Backend ref={ref} {...backendProps} />
})

Player.displayName = 'Player'

export { Player }
